import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useSymbolPrices } from '../../../context/WebSocketContext';

const SpreadValue = ({ symbolId }) => {
    const allSymbolParams = useSelector((state) => state.symbol.allSymbolParams);
    const { [symbolId]: symbol } = useSymbolPrices();
    const [spread, setspread] = useState(0)
    const calculateSpread = (spreadType, spreadValue, ask, bid, digits) => {
        const power = Math.pow(10, digits || 0);
        const diff = (ask * power) - (bid * power);
        return spreadType === 0
            ? parseInt(spreadValue || 0)
            : Math.max(0, parseInt(diff + (spreadValue || 0)));
    };
    useEffect(() => {
        const symbolParams = allSymbolParams?.[symbolId] || {};
        if (symbolId == 57) {
            console.log(symbolParams)
        }
        const spreadType = symbolParams?.spreadType;
        const spreadValue = symbolParams?.spreadValue;
        setspread(calculateSpread(spreadType, spreadValue, symbol?.ask, symbol?.bid, symbol?.digits))
    }, [symbol])

    return (
        <div>{spread}</div>
    )
}

export default SpreadValue